import React from 'react';
import cn from 'classnames';
import Tabs from '../../common/Tabs/Tabs';
import Tab from '../../common/Tab/Tab';
import styles from './EntrancesTabs.module.scss';

const EntrancesTabs = ({
  tabsValue,
  onChange,
  items,
  labelKey = 'name',
  valueKey = 'name',
  className,
}) => {
  return (
    <Tabs
      className={cn(styles.tabs, className)}
      value={tabsValue}
      onChange={onChange}
    >
      {items.map((item, index) => (
        <Tab
          className={styles.tab}
          selectedClassName={styles.tabActive}
          key={item.id || index}
          label={item[labelKey]}
          value={item[valueKey]}
        />
      ))}
    </Tabs>
  );
};

export default EntrancesTabs;
